var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortSvgAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4999 9.16665H14.5001C14.599 9.16662 14.6956 9.13551 14.7778 9.07724C14.86 9.01897 14.9241 8.93615 14.9619 8.83927C14.9998 8.74238 15.0097 8.63577 14.9904 8.53292C14.9711 8.43007 14.9235 8.33559 14.8536 8.26142L10.3535 3.48871C10.3071 3.43945 10.252 3.40037 10.1913 3.3737C10.1307 3.34704 10.0657 3.33331 10 3.33331C9.93434 3.33331 9.86932 3.34704 9.80867 3.3737C9.74801 3.40037 9.6929 3.43945 9.64649 3.48871L5.1464 8.26142C5.07649 8.33559 5.02889 8.43007 5.0096 8.53292C4.99032 8.63577 5.00022 8.74238 5.03806 8.83927C5.07589 8.93615 5.13996 9.01897 5.22217 9.07724C5.30438 9.13551 5.40103 9.16662 5.4999 9.16665Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 10.8333H5.4999C5.40103 10.8333 5.30438 10.8644 5.22217 10.9227C5.13996 10.981 5.07589 11.0638 5.03806 11.1607C5.00022 11.2576 4.99032 11.3642 5.0096 11.467C5.02889 11.5699 5.07649 11.6644 5.1464 11.7385L9.64649 16.5113C9.6929 16.5605 9.74801 16.5996 9.80867 16.6263C9.86933 16.6529 9.93434 16.6666 10 16.6666C10.0657 16.6666 10.1307 16.6529 10.1913 16.6263C10.252 16.5996 10.3071 16.5605 10.3535 16.5113L14.8536 11.7385C14.9235 11.6644 14.9711 11.5699 14.9904 11.467C15.0097 11.3642 14.9998 11.2576 14.9619 11.1607C14.9241 11.0638 14.86 10.981 14.7778 10.9227C14.6956 10.8644 14.599 10.8333 14.5001 10.8333Z",
    fill: "#88C3E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortSvgAsc);
export default __webpack_public_path__ + "static/media/SortSvgASC.d2ec68b39cb6b1fe73d9eadd0000cca5.svg";
export { ForwardRef as ReactComponent };